// extracted by mini-css-extract-plugin
module.exports = {"loadingDots__dot":"LoadingDots__loadingDots__dot__3e24j","loadingDots":"LoadingDots__loadingDots__1ygJA","dot-keyframes":"LoadingDots__dot-keyframes__3AhpQ"};